import ButtonBase from '@mui/material/ButtonBase';
import { styled } from '@mui/material/styles';

interface FileInlineRenameSaveButtonStyleProps {
  isSaveAction: boolean;
}

const shouldForwardSaveButtonProp = (prop: PropertyKey) => prop !== 'isSaveAction';

export const FileInlineRenameRoot = styled('span')(({ theme }) => ({
  alignItems: 'center',
  border: `1px solid ${theme.palette.brand[500]}`,
  borderRadius: 'var(--file-inline-rename-radius, var(--measurement-date-documents-tree-radius-xs, var(--documents-list-panel-radius-xs, 4px)))',
  boxSizing: 'border-box',
  color: theme.palette.brand[500],
  display: 'inline-flex',
  flex: '0 1 auto',
  justifySelf: 'start',
  lineHeight: 'inherit',
  maxWidth: '100%',
  minWidth: 0,
  padding: 'var(--file-inline-rename-padding-y, 2px) var(--file-inline-rename-padding-x, 4px)',
  width: 'fit-content',
}));

export const FileInlineRenameInput = styled('input')(({ theme }) => ({
  background: 'transparent',
  border: 0,
  color: 'inherit',
  flex: '0 1 auto',
  font: 'inherit',
  lineHeight: 'inherit',
  maxWidth: 'min(100%, 28ch)',
  minWidth: '4ch',
  outline: 0,
  padding: 0,
  '&::selection': {
    backgroundColor: theme.palette.brand[100],
  },
}));

export const FileInlineRenameExtension = styled('span')({
  color: 'inherit',
  flex: '0 0 auto',
  font: 'inherit',
  lineHeight: 'inherit',
  minWidth: 0,
});

export const FileInlineRenameSaveButton = styled(ButtonBase, {
  shouldForwardProp: shouldForwardSaveButtonProp,
})<FileInlineRenameSaveButtonStyleProps>(({ isSaveAction, theme }) => ({
  alignItems: 'center',
  backgroundColor: isSaveAction ? theme.palette.brand[500] : 'transparent',
  borderRadius: 'var(--file-inline-rename-radius, 4px)',
  color: isSaveAction ? theme.palette.neutral.white : theme.palette.neutral[500],
  display: 'inline-flex',
  flex: '0 0 var(--file-inline-rename-action-size, 20px)',
  height: 'var(--file-inline-rename-action-size, 20px)',
  justifyContent: 'center',
  marginLeft: 'var(--file-inline-rename-padding-x, 4px)',
  minHeight: 'var(--file-inline-rename-action-size, 20px)',
  minWidth: 'var(--file-inline-rename-action-size, 20px)',
  padding: 0,
  transition: theme.transitions.create(['background-color', 'color', 'opacity'], {
    duration: theme.transitions.duration.shortest,
  }),
  width: 'var(--file-inline-rename-action-size, 20px)',
  '&:hover, &:focus-visible': {
    backgroundColor: isSaveAction ? theme.palette.brand[600] : theme.palette.neutral[100],
    color: isSaveAction ? theme.palette.neutral.white : theme.palette.neutral[700],
    outline: 0,
  },
  '&.Mui-disabled': {
    backgroundColor: isSaveAction ? theme.palette.brand[100] : 'transparent',
    color: isSaveAction ? theme.palette.brand[500] : theme.palette.neutral[300],
    opacity: 1,
  },
  '& svg': {
    display: 'block',
    fontSize: 'var(--file-inline-rename-action-icon-size, 16px)',
  },
}));
